import { Helmet } from 'react-helmet'
import styled from 'styled-components/macro'
import Loader from 'components/misc/Loader'
import { useLocalization } from 'localization'

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.white};
`

const LoadingPage = () => {
  const { t } = useLocalization()

  return (
    <Container>
      <Helmet>
        <title>{t('dweb_loading_loading')}</title>
      </Helmet>
      <Loader size="70" />
    </Container>
  )
}

export default LoadingPage
